import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { BankAccountResponseDto } from "../../dtos/bank-account-dto";
import { BankAccountService } from "../../services/bank-account-service";

export const useGetBankAccountListQuery = ({
  options
}: {
  options?: Omit<
    UseQueryOptions<BankAccountResponseDto>,
    "queryKey" | "queryFn"
  >;
} = {}) => {
  return useQuery({
    queryKey: ["bankAccountList"],
    queryFn: async () => await BankAccountService.getList(),
    ...options
  });
};
